var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2123_1776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.48444 20 0 15.5156 0 10C0 4.48444 4.48444 0 10 0C15.5156 0 20 4.48444 20 10C20 15.5156 15.5156 20 10 20ZM10 1.33333C5.22222 1.33333 1.33333 5.22222 1.33333 10C1.33333 14.7778 5.22222 18.6667 10 18.6667C14.7778 18.6667 18.6667 14.7778 18.6667 10C18.6667 5.22222 14.7778 1.33333 10 1.33333Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12C8.89778 12 8 11.1022 8 10C8 8.89778 8.89778 8 10 8C11.1022 8 12 8.89778 12 10C12 11.1022 11.1022 12 10 12ZM10 9.33333C9.63111 9.33333 9.33333 9.63111 9.33333 10C9.33333 10.3689 9.63111 10.6667 10 10.6667C10.3689 10.6667 10.6667 10.3689 10.6667 10C10.6667 9.63111 10.3689 9.33333 10 9.33333Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 9.3335C9.63127 9.3335 9.3335 9.03572 9.3335 8.66683V4.00016C9.3335 3.63127 9.63127 3.3335 10.0002 3.3335C10.3691 3.3335 10.6668 3.63127 10.6668 4.00016V8.66683C10.6668 9.03572 10.3691 9.3335 10.0002 9.3335Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.9998C13.1644 13.9998 12.9911 13.9331 12.8622 13.8042L10.4711 11.4131C10.2089 11.1509 10.2089 10.7287 10.4711 10.4709C10.7333 10.2131 11.1555 10.2087 11.4133 10.4709L13.8044 12.862C14.0666 13.1242 14.0666 13.5464 13.8044 13.8042C13.6755 13.9331 13.5022 13.9998 13.3333 13.9998Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2123_1776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7e1185927240a42eff67287413d59f4d.svg";
export { ForwardRef as ReactComponent };